import { Link } from "react-router-dom";
import { MessageCircle, Smile, BellRing } from "lucide-react";
import { SectionHead, PhoneShot } from "@/components/landing/Kit";

const POINTS = [[MessageCircle, "Chatte direkt aus jeder Seite – ein Tipp auf die Chat-Blase genügt"], [Smile, "Mit Emojis, privat und nur mit deinen Freunden"], [BellRing, "Push-Benachrichtigung, sobald dir jemand schreibt"]];

export const NewChatPromo = () => (
  <section className="max-w-6xl mx-auto px-4 sm:px-6 py-10 sm:py-14" data-testid="landing-new-chat">
    <div className="relative overflow-hidden rounded-[2.5rem] bg-white border border-pink-100 p-6 sm:p-12 grid md:grid-cols-[1.2fr_1fr] gap-8 items-center shadow-xl shadow-rose-100/60">
      <div className="space-y-5">
        <SectionHead eyebrow="Neue Funktion" title="Der neue" accent="Chat-Messenger" />
        <ul className="space-y-3">
          {POINTS.map(([I, t]) => <li key={t} className="flex items-start gap-3 text-slate-600"><span className="w-8 h-8 shrink-0 rounded-full bg-rose-50 text-rose-500 flex items-center justify-center"><I className="w-4 h-4" /></span><span className="pt-1">{t}</span></li>)}
        </ul>
        <Link to="/registrieren" data-testid="landing-new-chat-cta" className="inline-flex items-center gap-2 px-6 h-12 rounded-full pink-gradient text-white font-bold text-sm shadow-lg shadow-rose-200 hover:scale-[1.02] transition-transform">Jetzt mitchatten</Link>
      </div>
      <PhoneShot src="/screens/chat.jpg" alt="Der Chat in der App" testId="landing-phone-chat" chips={[{ icon: MessageCircle, title: "Neue Nachricht", sub: "von Ben" }, { icon: BellRing, title: "Push aufs Handy", sub: "sofort informiert" }]} />
    </div>
  </section>
);
